var map = {
	"./da-DK.json": "HAMd",
	"./de-DE.json": "+uEJ",
	"./en-AU.json": "/W3d",
	"./en-US.json": "+gqc",
	"./es-ES.json": "K55d",
	"./fr-CA.json": "uxbr",
	"./fr-FR.json": "9n+o",
	"./id-ID.json": "S31k",
	"./it-IT.json": "oBhQ",
	"./ja-JP.json": "+B+r",
	"./ko-KR.json": "GHc4",
	"./nb-NO.json": "pjwK",
	"./nl-NL.json": "JUxS",
	"./pt-BR.json": "OYD0",
	"./ru-RU.json": "Ae0S",
	"./sv-SE.json": "rF/Y",
	"./th-TH.json": "n7NV",
	"./tr-TR.json": "ciIN",
	"./vi-VN.json": "DWGE",
	"./zh-HK.json": "1+D7",
	"./zh-TW.json": "JzTv"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hFeb";


//////////////////
// WEBPACK FOOTER
// ./src/locales [A-Za-z0-9-_,\s]+\.json$/
// module id = hFeb
// module chunks = 1 2